import React, { useContext } from 'react';
import classNames from 'classnames';
import { isEmpty } from 'lodash';
import { I18nProvider } from '@fiverr-private/fiverr_context';
import ScTilesCarousel from '../common/sc_tiles_carousel';
import { isQueryInTilesTest } from '../../experiments/serviceTilesSearch/utils';
import { DOMINATE_SC_FOR_SEARCH } from '../../experiments/serviceTilesSearch/constants';
import TopFiltersCarousel from '../common/top_filters_carousel';
import { MINIMUN_TILES_LENGTH } from '../common/tiles_carousel/constants';
import { getScTilesData } from '../common/sc_tiles_carousel/utils';
import { getFilterTilesCarousel } from '../common/top_filters_carousel/utils';
import { SearchPropTypes } from '../../types/index';
import { AppContext } from '../context/listingsContext';
import { DesktopTopBar, TouchTopBar } from '../common/top_bar';
import { BusinessEmptyResults } from '../common';
import BusinessListings from '../common/listings/BusinessListings';
import SearchResultsCounter from './search_results_counter';
import RelatedSearch from './related_search';
import SearchHeader from './search_header';

const BusinessSearch = (props) => {

    const {
        displayData,
        appFilters,
        pagination
    } = props;

    const { isTouch,
        listings: [listings],
        isDefaultLocale,
        dominateSubCategoryId,
        significantLeafCategories = [],
        inSearchServiceTiles,
        query
    } = useContext(AppContext);

    const { subCategory, active } = appFilters;
    const allGigs = [ ...listings.gigs, ...listings.restOfGigs ];
    const hasGigs = allGigs.length > 0;
    const isEmptySearch = isEmpty(active) && !hasGigs;
    const subCatFiltersCarousel = getFilterTilesCarousel(dominateSubCategoryId);
    const scTilesData = getScTilesData(significantLeafCategories, subCategory);
    const shouldShowFiltersCarousel = inSearchServiceTiles && isQueryInTilesTest(query) && DOMINATE_SC_FOR_SEARCH.includes(dominateSubCategoryId);
    const shouldShowScCarousel = !shouldShowFiltersCarousel && scTilesData.length >= MINIMUN_TILES_LENGTH;
    const shouldShowRelatedSearch = isDefaultLocale && !isEmptySearch && !shouldShowScCarousel && !shouldShowFiltersCarousel;

    return (
        <div className={classNames('search-page', { 'top-filters': !isTouch })}>
            { shouldShowRelatedSearch && <RelatedSearch displayData={displayData}/>}
            { hasGigs &&
                <>
                    {isTouch ?
                        <I18nProvider>
                            {({ i18n }) => (
                                <SearchResultsCounter paginationData={pagination} displayData={displayData} i18n={i18n}/>
                            )}
                        </I18nProvider> :
                        <div className="layout-row header-wrapper">
                            <SearchHeader subCategoryData={subCategory} searchData={displayData.searchComponentData}/>
                        </div>
                    }
                    {
                        shouldShowFiltersCarousel &&
                        <div className="layout-row">
                            <TopFiltersCarousel topFiltersCarousel={subCatFiltersCarousel} subCategoryId={dominateSubCategoryId}/>
                        </div>
                    }
                    {
                        shouldShowScCarousel &&
                        <div className="layout-row">
                            <ScTilesCarousel scTilesData={scTilesData}/>
                        </div>
                    }
                    {isTouch ?
                        <TouchTopBar gigs={allGigs}/> :
                        <DesktopTopBar gigs={allGigs} fromSearchFlow/>
                    }
                </>
            }
            { isEmptySearch ? <BusinessEmptyResults/> : <BusinessListings/> }

        </div>
    );
};

BusinessSearch.propTypes = SearchPropTypes;

export default BusinessSearch;
